
<!--header-->
<div class="header">
    <!-- Logo -->
    <div class="header-left d-xl-none d-lg-none">
      <a [routerLink]="['/dashboard']" class="logo">
        <img src="assets/img/logo.png" width="110" height="35" alt="" />
      </a>
    </div>
  
    <!-- /Logo -->
    <a
      id="toggle_btn"
      (click)="toggleSidebar()"
      href="javascript:void(0);"
    >
      <span class="bar-icon">
        <span></span>
        <span></span>
        <span></span>
      </span>
    </a>
    <!-- Header Title -->
    <div class="page-title-box d-lg-block cus-title1">
      <a [routerLink]="['/dashboard']" class="logo pt-2">
        <img src="assets/image/mobiliselogo.png" width="120" alt="" />
      </a>
    </div>
  
    <!-- /Header Title -->
    <!-- Header Menu -->
    <ul class="nav user-menu">
    </ul>
  </div>
  <!--/header-->
<div class="page-wrapper" style="min-height: 347px">
    <div class="col col-xs-12">
        <div class="padding-main-side table-filter2">
            <div class="container">
                <div class="row">
                    <div class="col-8">
                        <div class="sec_1">
                            <div class="row">
                                <div class="col-9">
                                    <div class="job_h">
                                        <h2 class="font-weight-bold">{{ijp_detail.desig_desc}}</h2>
                                        <div class="">
                                            <p>
                                                <!-- Capgemini <span class="color_s"><i class="fa fa-star"></i>3.9 | -->
                                                {{ijp_detail.views}} Views
                                                <!-- </span> -->
                                            </p>
                                        </div>
                                    </div>
                                    <ul class="job-post-det">
                                        <li>
                                            <i class="fa fa-suitcase"></i> {{ijp_detail.exp_frm}} - {{ijp_detail.exp_to}} years
                                        </li> 
                                        <li> | </li>
                                        <li>
                                            <i class="fa fa-inr m-r-5"></i> Not Disclosed 
                                        </li>
                                    </ul>
                                    <p><span class="color_s"><i class="fa fa-map-marker"></i> {{ijp_detail.address1}}
                                        <br> {{ijp_detail.ct_name}} {{ijp_detail.st_name}}</span></p>
                                </div>
                                <div class="col-3">
                                    <div class="job_img text-center">
                                        <img src="assets/img/logo.png">
                                        <div class="btext mt-3">
                                            <p><a href="#">Send me jobs like this</a></p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="border-top pt-3">
                                        <div class="row">
                                            <div class="col-6">
                                                <div class="text_d">
                                                    <p>Posted Date : <b>{{ijp_detail.created_at}}</b> |
                                                        Job Applicants: <b>{{ijp_detail.applicants}}</b></p>
                                                </div>
                                            </div>
                                            <div class="col-6 text-right">
                                                <div class="buttonsec">
                                                    <div class="apply-button-container">
                                                    <div class="row">
                                                        <ul class="d_flex Social_i">
                                                            <li>
                                                                <i class="fa fa-facebook-f"></i>
                                                            </li>
                                                            <li>
                                                                <a href="#" target="_blank">
                                                                <i class="fa fa-instagram"></i></a>
                                                            </li>
                                                            <li>
    
                                                                <a href="#" target="_blank">
                                                                <i class="fa fa-twitter"></i></a>
                                                            </li>
                                                            <li>
                                                                <a href="#" target="_blank"><i class="fa fa-linkedin"></i></a>
                                                            </li>
                                                        </ul>
                                                        
                                                        <div class="col-md-6">
                                                            <span *ngIf="empStatus == 'ex'">
                                                                <button id="logToApp" class="login-apply-button loginBtn" *ngIf="ijp_detail.is_applied != 0">Applied</button>
                                                                <a *ngIf="ijp_detail.is_applied == 0" class="login-apply-button loginBtn" href="javascript:void(0);" data-toggle="modal" (click)="addJobModal('231')">Apply Now</a>
                                                            </span>
                                                            <span (click)="addJobModal('')">
                                                                <button   *ngIf="empEntity" id="regToApp" class="login-apply-button loginBtn" >Refer A Candidate</button>
                                                                <button  *ngIf="!empEntity" id="regToApp"class="login-apply-button loginBtn"  >Apply Now</button>
                                                            </span>
                                                        </div>
                                                    </div>    
                                                        <!-- <button id="regToApp" class="reg-apply-button"  *ngIf="empEntity != '2'" (click)="shareMedia1()">Share on Social Media</button> -->
                                                        
                                                        <!-- <button id="logToApp" class="login-apply-button loginBtn">Apply Now</button> -->
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="sec_1 mt-3">
                            <div class="row">
                                <div class="col-12">
                                    <div class="job_h">
                                        <h3 class="font-weight-bold">Job Description :</h3>
                                        <div class="text_sec">
                                            <span [innerHtml]="ijp_detail.short_desc"></span>
                                            <p class="mt-4"><b>Role:</b> Technical Lead</p>
                                            <p class="mt-4"><b>Industry Type:</b>  IT Services & Consulting</p>
                                            <p class="mt-4"><b>Department:</b>  Engineering - Software & QA</p>
                                            <p class="mt-4"><b>Employment Type:</b>  Full Time, Permanent</p>
                                            <p class="mt-4"><b>Role Category:</b>  Software Development</p>
                                            <p class="mt-4"><b></b>  </p>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="sec_1">
                             <div class="border-bottom mb-2">
                                <h3 class="m-0 border-bottom mt-2"><b>Related Jobs</b></h3>
                                <div class="row ">
                                    <div class="col-12">
                                        <div class="heading_s border-bottom mt-2" *ngFor="let listJobs of ijp_detail_desc ;let i = index;"> 
                                            <h4 class="m-0">{{listJobs.desig_desc}}</h4> 
                                                <p><span class="color_s"><i class="fa fa-map-marker"></i> {{listJobs.cost_center}} , {{listJobs.ct_name}} , {{listJobs.st_name}}</span></p>
                                                <ul class="job-post-det">
                                                    <li>
                                                        <i class="fa fa-calendar"></i> Posted Date: <span class="text-blue">{{listJobs.created_at}}</span>
                                                    </li>
                                                    <li>
                                                        <i class="fa fa-users m-r-5"></i> Total Applications: <span class="text-blue">{{listJobs.applicants}}</span>
                                                    </li>
                                                    <li>
                                                        <i class="fa fa-eye m-r-5"></i> Views: <span class="text-blue">{{listJobs.views}}</span>
                                                    </li>
                                                </ul> 
                                        </div>
                                    </div>
        
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
           <!-- Fotter Start -->
           <div class="Foot_sec mt-3 pt-3">
            <div class="row">
                <div class="col-2">
                    <div class="fot_sec">
                        <div class="img_fotter">
                            <img src="assets/image/mobiliselogo.png">
                        </div>
                        <div class="social_icn mt-4">
                            <p class="font-weight-bold">Connect with us</p>
                            <ul class="d_flex Social_i">
                                <li>
                                    <i class="fa fa-facebook-f"></i>
                                </li>
                                <li>
                                    <a href="#" target="_blank">
                                    <i class="fa fa-instagram"></i></a>
                                </li>
                                <li>

                                    <a href="#" target="_blank">
                                    <i class="fa fa-twitter"></i></a>
                                </li>
                                <li>
                                    <a href="#" target="_blank"><i class="fa fa-linkedin"></i></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- <div class="col-7">
                    <div class="row">
                        <div class="col-4">
                            <div class="linkSec">
                                <ul class="">
                                    <li>About</li>
                                    <li>Career</li>
                                    <li>Employer Home</li>
                                    <li>Sitemap</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="linkSec">
                                <ul class="">
                                    <li>Help center</li>
                                    <li>Summons/Notices</li>
                                    <li>Grievances</li>
                                    <li>Report issue</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="linkSec">
                                <ul class="">
                                    <li>Privacy policy</li>
                                    <li>Terms & Conditions</li>
                                    <li>Fraud alert</li>
                                    <li>Trust & Safety</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-3">
                    <div class="fot_border">
                        <p class="text_ff">Apply on the go</p>
                        <p>Get real-time job updates on our App</p>
                        <div class="nI-gNb-app-cont">
                            <a href="#" rel="noreferrer" class="nI-gNb-appdownload" target="_blank">
                                <img loading="lazy" alt="naukri app download" src="assets/img/playstore.png" height="44" width="149"></a>
                            <a href="#" rel="noreferrer" class="nI-gNb-appdownload" target="_blank">
                                <img loading="lazy" alt="naukri app download" src="assets/img/playstore.png" height="44" width="149"></a>
                        </div>
                    </div>
                </div> -->
                <div class="col-10">
                    <div class="ImageSec">
                        <img src="assets/img/sdx2.jpg">
                    </div>
                </div>
            </div>
       </div>
       <!-- Fotter End -->
        </div>
    </div>
</div>
<!-- /Page Wrapper -->

<!--socal media modal-->

<div class="modal custom-modal fade" id="socal_media" role="dialog" style="display: none;" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Social Media</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                   <span aria-hidden="true">×</span>
               </button>
            </div>
            <div class="modal-body">
                <p class="text-center h5">Job Posting on Social Media</p>
                <div class="row text-center">

                    <div class="col-4">
                        <a href="https://www.facebook.com/sharer/sharer.php?u={{fb_share}}/facebook" target="_blank">
                            <img src="assets/img/social-icon/facebook.png" style="height: 30px;">
                        </a>
                        <!-- <a href="https://www.facebook.com/login.php" target="_blank">
                      </a> -->
                        <!-- <i class="fa fa-facebook fa-2x"></i> -->
                        <p>facebook</p>
                    </div>
                    <div class="col-4">
                        <a href="https://www.linkedin.com/sharing/share-offsite/?url={{fb_share}}/linkedin" target="_blank">
                            <img src="assets/img/social-icon/linkedin.png" style="height: 30px;">
                            <!-- <i class="fa fa-linkedin fa-2x"></i> -->
                        </a>
                        <p>linkedin</p>
                    </div>
                    <div class="col-4">
                        <a href="https://wa.me/?text={{fb_share}}/whatsapp" target="_blank">
                            <img src="assets/img/social-icon/whatsapp.png" style="height: 30px;">
                        </a>

                        <p>Whats App</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--end socal media modal-->

<!--Refer a friends modal -->

<div id="apply_job_modal" class="modal custom-modal fade" role="dialog" style="display: none;" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
           <span aria-hidden="true">×</span>
           </button>
            </div>
            <div class="card mb-0 card-border0">
                <div class="card-body card-body-top">
                    <form [formGroup]="jobApplyForm" (ngSubmit)="applyJob()">
                        <div class="row">
                            <div class="col-lg-12">
                                <h3 class="card-title mb-0">New Candidate</h3>
                                <hr/>

                                <div class="row">
                                    <div class="form-group col-md-6">
                                        <label for="exampleFormControlTextarea1">CV</label>
                                        <div class="upload-btn-wrapper text-center text-primary">
                                            <i class="fa fa-upload fa-5x"></i>
                                            <h5 class="mt-3" id="candEmpFile">Upload file</h5>
                                            <input type="file" class="form-control" (change)="onFileChangeCv($event)" />
                                        </div>
                                        <h5 class="text-primary">Max file size: 10MB. File format: doc, docx, pdf..</h5>
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label for="exampleFormControlTextarea1">Photo</label>
                                        <div class="upload-btn-wrapper text-center text-primary">
                                            <i class="fa fa-image fa-5x"></i>
                                            <h5 class="mt-3" id="candEmpPhoto">Image</h5>
                                            <input type="file" class="form-control" (change)="onFileChangePhoto($event)" />
                                        </div>
                                        <h5 class="text-primary">Max file size: 2MB. File format: png, jpg, jpeg.</h5>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col-md-6">
                                        <label for="firstName" class="title">First Name <span class="form-error">*</span></label>
                                        <input type="text" formControlName="first_name" class="form-control" />
                                        <div *ngIf="submitted && apply.first_name.errors" class="form-error">
                                            <div *ngIf="apply.first_name.errors.required">First name is required</div>
                                        </div>
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label for="lastName">Last Name <span class="form-error">*</span></label>
                                        <input type="text" formControlName="last_name" class="form-control" />
                                        <div *ngIf="submitted && apply.last_name.errors" class="form-error">
                                            <div *ngIf="apply.last_name.errors.required">Last name is required</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col-md-6">
                                        <label for="emailAddress">Email Address </label>
                                        <input type="email" class="form-control" formControlName="email" />
                                        <!-- <div *ngIf="submitted && apply.email.errors" class="form-error"> -->
                                        <!-- <div *ngIf="apply.email.errors.required">Email is required</div> -->
                                        <div *ngIf="(submitted || apply.email.touched) && apply.email.errors" class="form-error">
                                            <!-- <div *ngIf="apply.email.errors.email">Email address must be valid</div> -->
                                            <div *ngIf="apply.email.errors.email">Email must be a valid email address</div>
                                        </div>
                                        <!-- </div> -->
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label for="phoneNumber">Phone Number <span class="form-error">*</span></label>
                                        <input type="text" class="form-control" formControlName="phone" maxlength="10" />
                                        <div *ngIf="(submitted || apply.phone.touched) && apply.phone.errors" class="form-error">
                                            <div *ngIf="apply.phone.errors.required">Phone number is required</div>
                                            <div *ngIf="apply.phone.errors.minlength">Phone number must be of 10 characters</div>
                                            <div *ngIf="apply.phone.errors.maxlength">Phone number must be of 10 characters</div>
                                            <div *ngIf="apply.phone.errors.pattern">Enter only number.</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="form-group col-md-6">
                                        <label for="forGender">Gender </label>
                                        <select2 [data]="gendList" value="value" placeholder="Gender" formControlName="gender">
                                        </select2>
                                        <div *ngIf="submitted && apply.gender.errors" class="form-error">
                                            <div *ngIf="apply.gender.errors.required">Gender is required</div>
                                        </div>
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label for="Compitency">Key Skills </label>
                                        <input type="text" class="form-control" formControlName="compitency" />
                                        <div *ngIf="submitted && apply.compitency.errors" class="form-error">
                                            <div *ngIf="apply.compitency.errors.required">Key Skills is required</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="form-group col-md-6">
                                        <label for="forAadhar">Aadhar number</label>
                                        <input type="text" formControlName="aadhar_no" class="form-control" maxlength="12" />
                                        <div *ngIf="(submitted || apply.aadhar_no.touched) && apply.aadhar_no.errors" class="form-error">
                                            <div *ngIf="apply.aadhar_no.errors.required">Aadhar number is required</div>
                                            <div *ngIf="apply.aadhar_no.errors.minlength">Aadhar number must be of 12 characters</div>
                                            <div *ngIf="apply.aadhar_no.errors.maxlength">Aadhar number must be of 12 characters</div>
                                            <div *ngIf="apply.aadhar_no.errors.pattern">Enter only number.</div>
                                        </div>
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label for="coverLetter">Cover Letter</label>
                                        <textarea class="form-control" id="coverLetter" formControlName="cover_letter" rows="3"></textarea>
                                        <div *ngIf="submitted && apply.cover_letter.errors" class="form-error">
                                            <div *ngIf="apply.cover_letter.errors.required">Please enter cover letter</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 text-center">
                                        <button type="submit" [disabled]="loading" class="btn btn-primary btn-sm"> <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span> Submit</button>
                                        <button type="button" class="btn btn-danger btn-sm ml-10" (click)="resetJobApplyForm()">Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
<!--//Apply Job-->


